import { tokenDuck } from '../../store/jwtMiddleware';
import { queryClient } from '../../store/queryClient';
import { userQueryOptions } from './api/user';

const YEAR_MILLIS = 31556952000;

const createDateYearFromNow = () => new Date(Date.now() + YEAR_MILLIS).toString();

export const initializeFoundation = () => async dispatch => {
  try {
    const user = await queryClient.fetchQuery(userQueryOptions());
    if (user.roles.length === 0) {
      dispatch(tokenDuck.creators.setInvalidRoles());
      return;
    }
    const token = 'dummyToken';

    dispatch(tokenDuck.creators.setToken(token, 'refreshToken', createDateYearFromNow()));
  } catch (error) {
    return error;
  }
};

export const signoutZitadel = () => {
  globalThis.location.href = '/logout';
};
